import React, { FC, useEffect, useMemo } from 'react'
import { observer } from 'mobx-react'
import { Icon, Empty } from '@cps'
import { buyTogetherMobx, storeMobx, themeMobx, locationMobx } from '@mobxStore'
import { find, keyBy, sortBy } from '@dt/fe-utils/dist/lodash'
import StoreItem from '../StoreItem'
import './index.scss'

import noStoreCloseImg from '@img/no-store-close.png'
import { useHistoryNew } from '@utils'

interface IProps {
  /** 选择门店 */
  mapShow?: (type: boolean) => void;
  searchTitle?: string;
  clearMore?: (event: any) => void;
}

const StoreList: FC<IProps> = ({ clearMore, mapShow, searchTitle }) => {
  const history = useHistoryNew()

  /** 搜索地址 */
  const clearMap = (e) => {
    const ev = e || window.event
    ev.stopPropagation()
    mapShow(true)
  }

  /** 前往城市选择 */
  const handleToCity = (e) => {
    const ev = e || window.event
    ev.stopPropagation()
    history.push('/storeCitys')
  }

  return (
    <div className='change-input-bg' onClick={clearMore}>
      <div className='change-input'>
        {/* TODO 20231031 门店分页暂时不上 */}
        {/* <div className='city-wrap' data-cypid='change-city' onClick={handleToCity}>
          <div className='city-border-wrap'>
            <span className='city-name'>{storeMobx.cityName || i18n.t('store.storeCityTitle')}</span>
          </div>
        </div> */}
        <div className='search-input' data-cypid='search-address' onClick={clearMap}>
          <Icon name='search' />
          <span>{searchTitle}</span>
        </div>
      </div>
    </div>
  )
}
export default observer(StoreList)
